import { HttpClient } from "@angular/common/http";
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader } from "@ngx-translate/core";
import { map } from "rxjs";
import { APP_VERSION } from '@spotterworkspace/version';


export class SpotterMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        console.error("Missing translation for: " + params.key);
        console.error(params);
        return 'TransError: ' + params.key;
    }
}

// Translation loader removes empty strings so it can fallback to English
export function SpotterTranslationLoaderFactory(http: HttpClient) {
    return new SpotterTranslationLoader(http);
}


export class SpotterTranslationLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private prefix: string = '/spotter-shared/assets/i18n/',
        private suffix: string = '.json?v=' + APP_VERSION) {
    }

    public getTranslation(lang: string): any {
        return this.http.get(`${this.prefix}${lang}${this.suffix}`)
            .pipe(map(result => this.process(result)));
    }

    private process(object: Record<string, any>): Record<string, any> {
        return Object.keys(object)
            .filter(key => object.hasOwnProperty(key) && object[key] !== '')
            .reduce((result: Record<string, any>, key) => (result[key] = typeof object[key] === 'object' ? this.process(object[key]) : object[key], result), {});
    }
}
